import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
/**
 * Service that wraps the `localStorage` API functions with `try-catch` blocks to handle potential errors.
 * Errors are caught and logged to the console, but not thrown, allowing for graceful error handling
 * without interrupting the application flow.
 */
export class LocalStorageService {
  constructor() {}

  /**
   * Saves a key-value pair to local storage. Returns true if the operation is successful; otherwise, returns false.
   */
  setItem(key: string, value: string) {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (error) {
      console.error(
        `Unable to save on local storage (key:${key}, value: ${value})`,
        error
      );
      return false;
    }
  }

  /**
   * Retrieves the value associated with a key from local storage. If an error occurs, returns the value provided in `onErrorReturn`.
   */
  getItem(key: string) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error(`Unable to fetch from local storage (key:${key})`, error);
      return null;
    }
  }
}
